<template>
  <v-dialog
    v-model="isVisible"
    :overlay="false"
    fullscreen
    scrollable
    transition="dialog-bottom-transition"
  >
    <v-card v-if="receipt">
      <v-toolbar
        class="rounded-0"
        color="secondary"
        extended
        extension-height="40"
        flat
        height="60"
        max-height="100"
      >
        <v-avatar color="blue-grey lighten-1">
          <v-icon
            dark
            medium
          >
            mdi-receipt
          </v-icon>
        </v-avatar>

        <v-toolbar-title class="pl-3">
          <div class="body-3 grey--text text--lighten-3">
            {{ $tc('Receipt.Title', 1) }} {{ receipt.InternalId }}
          </div>
          <div class="text-caption grey--text  text--lighten-1">
            {{ receipt.InvoiceTypeCode }} {{ receipt.InvoiceTypeName }}
          </div>
        </v-toolbar-title>

        <v-spacer />

        <v-btn
          dark
          icon
          @click="isVisible = false"
        >
          <v-icon>close</v-icon>
        </v-btn>

        <template #extension>
          <v-tabs
            v-model="tab"
            background-color="secondary"
            class="rounded-0"
            dark
            grow
            show-arrows
            slider-color="white"
          >
            <v-tab
              class="cyan darken-2"
              value="tab-receipt-payload"
            >
              RECEIPT PAYLOAD
            </v-tab>

            <v-tab
              class="cyan darken-2"
              value="tab-receipt-response"
            >
              RECEIPT RESPONSE
            </v-tab>

            <v-tab
              class="indigo"
              value="tab-payment-payload"
            >
              PAYMENT PAYLOAD
            </v-tab>

            <v-tab
              class="indigo"
              value="tab-payment-response"
            >
              PAYMENT RESPONSE
            </v-tab>
          </v-tabs>
        </template>
      </v-toolbar>

      <v-card-text class="pa-0 fill-height">
        <v-tabs-items
          v-model="tab"
          class="fill-height"
        >
          <v-tab-item
            key="tab-receipt-payload"
            style="background-color: #1E1F22; color: #B7BBC1; overflow-y: auto; height: 100vh;"
          >
            <v-container fluid>
              <v-row dense>
                <v-col cols="12">
                  <pre
                    v-safe-html="syntaxHighlightReceiptPayload"
                    style="user-select: text;"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>

          <v-tab-item
            key="tab-receipt-response"
            style="background-color: #1E1F22; color: #B7BBC1; overflow-y: auto; height: 100vh;"
          >
            <v-container fluid>
              <v-row dense>
                <v-col cols="12">
                  <pre
                    v-safe-html="syntaxHighlightReceiptResponse"
                    style="user-select: text;"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>

          <v-tab-item
            key="tab-payment-payload"
            style="background-color: #1E1F22; color: #B7BBC1; overflow-y: auto; height: 100vh;"
          >
            <v-container fluid>
              <v-row dense>
                <v-col cols="12">
                  <pre
                    v-safe-html="syntaxHighlightPaymentPayload"
                    style="user-select: text;"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>

          <v-tab-item
            key="tab-payment-response"
            style="background-color: #1E1F22; color: #B7BBC1; overflow-y: auto; height: 100vh;"
          >
            <v-container fluid>
              <v-row dense>
                <v-col cols="12">
                  <pre
                    v-safe-html="syntaxHighlightPaymentResponse"
                    style="user-select: text;"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import AppData from '@/mixins/appdata'
import Auth from '@/mixins/auth'
import {syntaxHighlight} from '@/lib/helper/helper'

export default {
  name      : 'ReceiptDetailsDialog',
  components: {},
  mixins    : [Auth, AppData],
  props     : {
    visible: {
      type   : Boolean,
      default: false
    },
    receipt: {
      type   : Object,
      default: undefined
    }
  },
  data() {
    return {
      tab: 'tab-main'
    }
  },
  computed: {
    syntaxHighlightReceiptPayload() {
      return syntaxHighlight(this.receipt?.Data?.Payload)
    },
    syntaxHighlightReceiptResponse() {
      return syntaxHighlight(this.receipt?.Data?.Response)
    },

    syntaxHighlightPaymentPayload() {
      const data = this.receipt?.PaymentMethodsPayload
      if (data) data.PaymentMethodsUpdatedAt = this.receipt?.PaymentMethodsUpdatedAt || ''
      return syntaxHighlight(data)
    },
    syntaxHighlightPaymentResponse() {
      const data = this.receipt?.PaymentMethodsResponse
      if (data) data.PaymentMethodsUpdatedAt = this.receipt?.PaymentMethodsUpdatedAt || ''
      return syntaxHighlight(data)
    },

    isVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  watch: {
    isVisible() {
      this.tab = 'tab-main'
    }
  },
  updated() {
  },
  methods: {}
}
</script>

<style scoped>
:deep(pre) {
  outline: 1px solid #B7BBC1;
  padding: 5px;
  margin: 5px;
}
</style>
